import { useQuery } from '@hooks/reactQuery';

import { getDashboardAssetTypesSummary } from '@api/dashboardPO';

import { TDefaultDTO } from '@interfaces/common/defaultDTO';

import { refetchOptions } from '@constants/common';
import { DASHBOARD_ASSET_TYPES_SUMMARY } from '@constants/queryKeys';

const useQueryDashboardAssetTypesSummary = (params: TDefaultDTO) => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
	} = params;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [
			DASHBOARD_ASSET_TYPES_SUMMARY,
			page,
			pageSize,
			searchValue,
			sortFieldName,
			sortDirection,
		],
		queryFn: () => {
			return getDashboardAssetTypesSummary({
				...params,
				sortDirection: sortFieldName ? sortDirection : undefined,
			});
		},
		...refetchOptions,
	});

	return {
		dashboardDashboardAssetTypesSummary: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingDashboardAssetTypesSummary: (isLoading && !!data) || isFetching,
	};
};

export default useQueryDashboardAssetTypesSummary;

